<template>
  <div class="col-md-10 offset-md-1">
    <b-row>
      <b-col class="mb-3">
        {{ headline }}
      </b-col>
    </b-row>
    <upload
      ref="upload"
      :multiple="true"
      :showSubmitButton="false"
    />
  </div>
</template>

<script>
import Upload from '@/components/utils/upload/Upload';


export default {
  components: {
    Upload,
  },
  props: {
    headline: String,
  },
  computed: {
    model() {
      return { files: this.$refs.upload.files };
    },
  },
  methods: {
    reset() {
      this.$refs.upload.reset();
    },
  },
  mounted() {
    this.reset();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/AdditionalFilesForm.vue